
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {

	$w("#repeater7").onItemReady( ($item, itemData, index) => {
$item("#button46").label = itemData.label
$item("#button46").link = itemData.link
if (itemData._id === '4') {$item("#button46").style.borderColor = "#6a6158"}
	})

const desktopData = [
  {
    "_id": '1',
    "label":"關於我們",
    "link":"https://swallowlife.org/about"
  },
  {
    "_id":'2',
    "label":"聯絡我們",
    "link":"https://t.me/swallowlife"
  },
  {
    "_id":'3',
    "label":"追蹤我們",
    "link":"https://www.facebook.com/swallowlife"
  },
  {
    "_id":'4',
    "label":"請飲咖啡",
    "link":"https://www.swallowlife.org/plans-pricing"
  }
];

$w("#repeater7").data = desktopData;
});
